import cx, { clsx } from 'clsx';

import type { OAISchema } from '~/types/openapi';

import { BonuspackCloverFillIcon } from '~/assets/icons/membership';

type Props = OAISchema['MarketSelectProductResponseV2'] & {
  className?: string;
  wFull?: boolean;
  is3x2?: boolean;
  reverse?: boolean;
};

export function LuckyDiscountedPrice({
  className,
  wFull = true,
  is3x2,
  totalDiscountAmount,
  price,
  totalDiscountedPrice,
  reverse,
}: Props) {
  return (
    <div>
      <div className="text-description typo-footnote300-regular">
        {price.toLocaleString()}원
      </div>
      <div
        className={cx([
          reverse &&
            'inline-flex flex-row-reverse gap-[2px] mr-auto items-center whitespace-nowrap',
        ])}
      >
        <div className="text-membershipBlue-text typo-caption100-semibold">
          나의할인가
        </div>
        <div className="!font-bold !leading-[20px] text-membershipBlue-text typo-paragraph300-semibold">
          {totalDiscountedPrice?.toLocaleString()}원
        </div>
      </div>
      <div
        className={cx(
          'flex flex-col justify-start py-4 gap-[2px]',
          wFull ? 'w-full' : 'w-[140px]',
          className,
        )}
      >
        <p className="flex gap-2 text-bonuspackGreen-text typo-footnote300-semibold">
          <BonuspackCloverFillIcon />
          행운 보너스팩
        </p>
        <p
          className={clsx([
            'flex items-center justify-center rounded-[6px] bg-bonuspackGreen-background py-[3px] text-gray-000 typo-footnote300-semibold',
            is3x2 && 'text-center',
          ])}
        >
          최대{is3x2 && <br />} {totalDiscountAmount?.toLocaleString()}원 할인
        </p>
      </div>
    </div>
  );
}
